import { createAsyncThunk as reduxCreateAsyncThunk } from '@reduxjs/toolkit';

import { AppDispatch, RootState } from './index';

export const createAsyncThunk = reduxCreateAsyncThunk.withTypes<{
  state: RootState;
  dispatch: AppDispatch;
  rejectValue: string;
}>();
